import { HttpParams } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { API_BASE_URL_SERVICE } from '../../../../projects/kiene-core/src/lib/kiene-core.config';
import {
    FilterItem,
    FilterItemType,
} from '../../../../projects/kiene-core/src/lib/services/backend-api/classes/filter-item';
import { KieneFileService } from '../../../../projects/kiene-core/src/lib/services/files/kiene-file.service';
import { KieneTableService } from '../../components/kiene-table/kiene-table.service';
import { KieneBooleanTableColumn, TableColumn } from '../../components/kiene-table/table-column';
import { TableDescriptor, ToolbarButton } from '../../components/kiene-table/table-descriptor';
import { Condition, Operator, TableOption } from '../../components/kiene-table/table-option';
import { ConfirmDeleteDialogComponent } from '../../dialogs/confirm-delete-dialog/confirm-delete-dialog.component';
import { ArtikelLagerHistorieDialogComponent } from './artikel-lager-historie-dialog/artikel-lager-historie-dialog.component';
import { SonderpreisDialogComponent } from '../../warehouse/material/sonderpreis-dialog/sonderpreis-dialog.component';
import { ArtikelExcelImportDialogComponent } from './artikel-excel-import/artikel-excel-import-dialog/artikel-excel-import-dialog.component';

import { Material } from './material';
import { MessageService } from '../../../../projects/kiene-core/src/lib/services/message-service/message.service';
import { LocalStorageService } from '../../../../projects/kiene-core/src/lib/services/local-storage/local-storage.service';

@Component({
    selector: 'app-material',
    templateUrl: './material.component.html',
    styleUrls: ['./material.component.scss'],
})
export class MaterialComponent implements OnInit {
    tableDescriptor: TableDescriptor = new TableDescriptor();

    constructor(
        public dialog: MatDialog,
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
        private messageService: MessageService,
        private api: KieneTableService,
        private router: Router,
        private fileService: KieneFileService,
        private localStorageService: LocalStorageService,
    ) {}

    ngOnInit() {
        this.tableDescriptor.headline = 'Artikel';
        this.tableDescriptor.uniqueIdentifier = 'Artikel';
        this.tableDescriptor.apiUrl = this.apiBaseUrl + 'artikel/';
        this.tableDescriptor.route = '/lager/artikel/';
        this.tableDescriptor.nameOfIdField = 'artikel_id';
        this.tableDescriptor.searchPlaceholder = 'Artikel durchsuchen';

        this.tableDescriptor.columns.push(new TableColumn('artikel_id', 'ID'));
        if (this.localStorageService.hasPermission(3201)) {
            this.tableDescriptor.columns.push(new KieneBooleanTableColumn('gesperrt', 'Gesperrt', {}));
        }
        this.tableDescriptor.columns.push(new TableColumn('artikel_nr_intern', 'Artikel Nr.'));
        this.tableDescriptor.columns.push(new TableColumn('bezeichnung', 'Bezeichnung'));
        this.tableDescriptor.columns.push(new TableColumn('einheit', 'Einheit'));
        this.tableDescriptor.columns.push(new TableColumn('ean', 'EAN'));
        this.tableDescriptor.columns.push(new TableColumn('kuerzel', 'Kürzel'));
        this.tableDescriptor.columns.push(new TableColumn('lieferant', 'Lieferant'));
        this.tableDescriptor.columns.push(new TableColumn('warengruppe', 'Warengruppe'));
        this.tableDescriptor.columns.push(new TableColumn('editiert', 'Editiert', 'datetime'));
        this.tableDescriptor.standardCreate = false;

        this.tableDescriptor.disableConditions.push(new Condition('gesperrt', Operator.GROESSER, 0));

        this.tableDescriptor.permissionCreate = 1002;
        this.tableDescriptor.permissionView = 1001;

        this.tableDescriptor.options.push(
            new TableOption(this.navigateToDetails.bind(this), 'bearbeiten', 'edit', 1003),
        );
        this.tableDescriptor.options.push(new TableOption(this.confirmAndDelete.bind(this), 'löschen', 'delete', 1004));
        this.tableDescriptor.options.push(
            new TableOption(this.duplicate.bind(this), 'duplizieren', 'content_copy', 1002),
        );
        this.tableDescriptor.options.push(
            new TableOption(this.openSondpreisDialog.bind(this), 'Sonderpreise anzeigen', 'local_offer', 1002),
        );
        this.tableDescriptor.options.push(
            new TableOption(this.openLagerHistorieDialog.bind(this), 'Lagerhistorie', 'history', 1001),
        );

        this.tableDescriptor.toolbarButtons.push(
            new ToolbarButton(this.preislisteDownload.bind(this), 'euro', 1009, 'Preisliste herunterladen'),
        );

        this.tableDescriptor.toolbarButtons.push(
            new ToolbarButton(this.openExcelImportDialog.bind(this), 'upload', 1008, 'Artikel aus Excel importieren'),
        );

        this.tableDescriptor.filterItems.push(
            new FilterItem('Antibiotikum', 1, FilterItemType.CHECKBOX, 'antibiotikum', false),
        );
        this.tableDescriptor.filterItems.push(
            new FilterItem('Behandlungsartikel', 1, FilterItemType.CHECKBOX, 'behandlung', false),
        );
        this.tableDescriptor.filterItems.push(
            new FilterItem('Abgabeartikel', 1, FilterItemType.CHECKBOX, 'abgabe', false),
        );
        this.tableDescriptor.filterItems.push(
            new FilterItem('Impfstoff', 1, FilterItemType.CHECKBOX, 'impfung', false),
        );
        this.tableDescriptor.filterItems.push(
            new FilterItem('Mengenartikel', 1, FilterItemType.CHECKBOX, 'mengenartikel', false),
        );
        this.tableDescriptor.filterItems.push(
            new FilterItem('Betäubungsartikel', 1, FilterItemType.CHECKBOX, 'betaeubungsmittel', false),
        );
        this.tableDescriptor.filterItems.push(
            new FilterItem('Gesperrte Artikel', 1, FilterItemType.CHECKBOX, 'gesperrt', false),
        );

        this.tableDescriptor.initialSortColumn = 'bezeichnung';
        this.tableDescriptor.initialSortDirection = 'asc';
        this.tableDescriptor.addVoid = this.gotoNeu.bind(this);
    }

    gotoNeu() {
        this.router.navigate(['lager', 'artikel', 'neu']).then();
    }

    private confirmAndDelete(artikel: Material) {
        const dialogRef = this.dialog.open(ConfirmDeleteDialogComponent, {
            width: '500px',
            data: { text: 'Wollen Sie den Artikel wirklich löschen?', title: 'Artikel löschen?' },
        });

        dialogRef.afterClosed().subscribe(response => {
            if (response) {
                this.deleteArtikel(artikel);
            }
        });
    }

    private navigateToDetails(artikel: Material) {
        this.router.navigate(['lager', 'artikel', artikel.artikel_id]).then();
    }

    openExcelImportDialog() {
        const dialogRef = this.dialog.open(ArtikelExcelImportDialogComponent, { width: '50%' });

        dialogRef.afterClosed().subscribe(() => {
            this.api.reload();
        });
    }

    preislisteDownload() {
        const params = new HttpParams();
        this.fileService.downloadCSV(this.apiBaseUrl + 'artikel/read_preisliste_csv.php', params);
    }

    duplicate(artikel: Material) {
        this.api.duplicateEntity(this.apiBaseUrl + 'artikel/duplicate.php', artikel).subscribe(
            response => {
                this.messageService.infoMessage('Der Artikel wurde erfolgreich dupliziert!');
                this.router.navigate(['lager', 'artikel', response.artikel_id]);
            },
            error => {
                this.messageService.errorMessage('Der Artikel konnte nicht dupliziert werden!', error);
            },
        );
    }

    deleteArtikel(artikel: Material) {
        this.api.deleteEntity(this.apiBaseUrl + 'artikel/delete.php', artikel).subscribe(
            () => {
                this.messageService.infoMessage('Der Artikel wurde erfolgreich gelöscht!');
                this.api.reload();
            },
            error => {
                this.messageService.errorMessage('Es ist ein Fehler beim Löschen aufgetreten! ', error);
            },
        );
    }

    private openSondpreisDialog(artikel: Material) {
        this.dialog.open(SonderpreisDialogComponent, { data: artikel });
    }

    private openLagerHistorieDialog(artikel: Material) {
        this.dialog.open(ArtikelLagerHistorieDialogComponent, {
            data: artikel,
            minWidth: '90%',
            maxWidth: '95vw',
        });
    }
}
